import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import mixins from './mixins'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);
import 'typeface-fira-sans';
import 'bootstrap'

//Jquery
window.$ = window.jQuery = require('jquery');

const moment = require('moment')
require('moment/locale/' + process.env.VUE_APP_MOMENT_LANGUAGE)

Vue.use(require('vue-moment'), {
  moment
})


import VueNoty from 'vuejs-noty'

Vue.use(VueNoty, {
  timeout: 4000,
  theme: 'bootstrap-v4',
  progressBar: true,
  layout: 'topRight'
});


import CountryFlag from 'vue-country-flag'

Vue.component('country-flag', CountryFlag)

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo);

import '@/lib/icons'

import Infopanel from './components/helpers/Infopanel.vue'
import Speaker from './components/helpers/Speaker.vue'
import ProcessingButton from "./components/helpers/ProcessingButton";
import Loader from './components/Loader';

Vue.component('Infopanel', Infopanel);
Vue.component('Speaker', Speaker);
Vue.component('Loader', Loader);
Vue.component('ProcessingButton', ProcessingButton);

Vue.config.productionTip = false;

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app');
